const gbpNoDecimals = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  maximumFractionDigits: 0,
});

const gbpWithPence = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Format a number as GBP. Shows pence only when the value isn't a whole pound
 * (so £150 stays £150, but £5.95 shipping keeps its pence).
 */
export const formatGBP = (n) => {
  const num = Number(n) || 0;
  const isWhole = Math.abs(num - Math.round(num)) < 0.005;
  return isWhole ? gbpNoDecimals.format(num) : gbpWithPence.format(num);
};

// Backwards-compat alias
export const formatINR = formatGBP;
